import { useQuery } from '@tanstack/react-query';
import { getSiloTokenPrice } from 'data/silo-token-price/client';

export const siloPriceKey = 'siloPrice';

export const useQuerySiloPrice = (disabled = false) => {
  return useQuery({
    queryKey: [siloPriceKey],
    queryFn: async () => getSiloTokenPrice(),
    enabled: !disabled,
  });
};
